<template>
    <v-container fluid class="py-0 px-0" ref="container">
        <v-tabs
            ref="tabs"
            active-class="white"
            background-color="grey lighten-3"
            hide-slider
        >
            <v-tab
                :to="{
                    name: 'main-work-orders',
                }"
            >
                WORK ORDERS
            </v-tab>
            <v-tab
                :to="{
                    name: 'approval-wo',
                }"
            >
                APPROVAL WO
            </v-tab>
            <v-tab
                v-if="approvedPermission"
                :to="{
                    name: 'approved-wo',
                }"
            >
                APPROVED WO
            </v-tab>
            <v-tab
                :to="{
                    name: 'alerts-dashboard',
                }"
                :class="alertsCount > 0 ? 'red--text' : ''"
            >
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <div v-on="on" class="d-flex align-center">
                            ALERTS
                            <v-badge
                                v-if="alertsCount > 0"
                                :content="alertsCount"
                                color="red"
                                inline
                                class="ml-2"
                            />
                        </div>
                    </template>
                    <span v-if="alertsCount > 0"
                        >{{ alertsCount }} alert(s) pending attention</span
                    >
                    <span v-else>No alerts</span>
                </v-tooltip>
            </v-tab>
            <v-tab
                :to="{
                    name: 'finished',
                }"
            >
                FINISHED
            </v-tab>
            <v-tab
                :to="{
                    name: 'wo-deliveries',
                }"
            >
                DELIVERIES
            </v-tab>
            <v-tab
                :to="{
                    name: 'wo-progress',
                }"
            >
                WO PROGRESS
            </v-tab>
            <v-tab
                v-if="readAllWO && readAllPL"
                :to="{
                    name: 'wo-packing-balance',
                }"
            >
                BALANCE
            </v-tab>
            <v-tab
                v-if="markQualityRegisters"
                :to="{
                    name: 'qa-pending-wo',
                }"
            >
                QA PENDING
            </v-tab>
            <v-tab
                v-if="markQualityRegisters"
                :to="{
                    name: 'qa-rejected-wo',
                }"
            >
                QA REJECTED
            </v-tab>
            <v-tab
                :to="{
                    name: 'approval-bom',
                }"
            >
                APPROVAL BOM
            </v-tab>
            <v-tab
                :to="{
                    name: 'approved-bom',
                }"
            >
                APPROVED BOM
            </v-tab>
            <v-tab
                :to="{
                    name: 'closed',
                }"
            >
                CLOSED
            </v-tab>
            <v-tab
                :to="{
                    name: 'canceled',
                }"
            >
                CANCELED
            </v-tab>
            <!-- <v-tab
                :to="{
                    name: 'assembly-stock',
                }"
            >
                Assembly Stock
            </v-tab> -->
        </v-tabs>
        <v-card flat>
            <v-card-text
                class="overflow-y-auto px-4 pt-4"
                :style="{ height: `${height}px` }"
            >
                <router-view />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import SocketioService from '@/services/websocket/socket.service.js'
import API from '@/services/api'
import { firestore } from '@/services/firebase'

export default {
    name: 'WorkOrders',
    data: () => ({
        loading: true,
        height: 0,
        companyId: JSON.parse(localStorage.getItem('company')),
        approvedPermission: undefined,
        markQualityRegisters: undefined,
        updateWOProcesses: undefined,
        readAllWO: false,
        readAllPL: false,
        alertsUnsubscribe: null,
        alertsCount: 0,
        liteWorkOrders: {},
    }),
    computed: {},
    async mounted() {
        this.onResize()
        const userPromise = API.getMyInfo()
        const projectsPromise = API.getWoProjects()
        const settingsPromise = API.getSettings()
        const {
            data: { user },
        } = await userPromise
        this.approvedPermission = user.permissions.includes('approvedWO')
        this.markQualityRegisters = user.permissions.includes(
            'markQualityRegisters'
        )
        this.updateWOProcesses = user.permissions.includes('updateWOProcesses')
        this.readAllWO = user.permissions.includes('readAllWO')
        this.readAllPL = user.permissions.includes('readAllPackingLists')
        SocketioService.connect({
            companyId: this.companyId,
        })
        const [liteWorkOrdersArray, liteProjects] = await Promise.all([
            API.getLiteWorkOrders(),
            projectsPromise,
        ])
        //transform array to object
        liteWorkOrdersArray.forEach(lwo => {
            lwo.projectManager = liteProjects[lwo.projectId]?.projectManager
            this.liteWorkOrders[lwo.id] = lwo
        })
        // Load settings to compute coordinator process IDs
        let coordinatedProcessIds = []
        try {
            const userId = JSON.parse(localStorage.getItem('userId'))
            const {
                data: { settings },
            } = await settingsPromise
            const processesSetting = settings.find(s => s.name === 'Processes')
            if (processesSetting?.processes && userId) {
                coordinatedProcessIds = processesSetting.processes
                    .filter(
                        p =>
                            Array.isArray(p.coordinators) &&
                            p.coordinators.includes(userId)
                    )
                    .map(p => p.id)
            }
        } catch (_) {
            coordinatedProcessIds = []
        }
        this.setupAlertsListener(user, coordinatedProcessIds)
    },
    beforeDestroy() {
        SocketioService.leaveRoom(`${this.companyId}-BOM`)
        SocketioService.disconnect()
        if (this.alertsUnsubscribe) {
            this.alertsUnsubscribe()
        }
    },
    methods: {
        onResize() {
            const {
                container: { clientHeight: containerHeight },
                tabs: {
                    $el: { clientHeight: tabsHeight },
                },
            } = this.$refs
            this.height = window.innerHeight - containerHeight - tabsHeight - 25
        },
        setupAlertsListener(user, coordinatedProcessIds = []) {
            const userId = JSON.parse(localStorage.getItem('userId'))
            const hasApprovalPermission = user.permissions?.includes(
                'approveProductionAlerts'
            )
            const alertsRef = firestore
                .collection('companies')
                .doc(this.companyId)
                .collection('alerts')

            this.alertsUnsubscribe = alertsRef.onSnapshot(
                snapshot => {
                    let count = 0
                    snapshot.forEach(doc => {
                        const woAlerts = { id: doc.id, ...doc.data() }
                        const wo = this.liteWorkOrders[woAlerts.id]
                        for (const alert of Object.values(
                            woAlerts.alerts || {}
                        )) {
                            if (
                                alert.status !== 'pending' &&
                                alert.status !== 'pending_approval'
                            )
                                continue

                            if (
                                (alert.currentStep === 'supervisor' &&
                                    (hasApprovalPermission ||
                                        coordinatedProcessIds.includes(
                                            alert.processId
                                        ))) ||
                                alert.createdBy == userId
                            ) {
                                count++
                            } else if (
                                (alert.currentStep === 'pm_designer' &&
                                    userId &&
                                    [
                                        wo?.projectManager,
                                        wo?.createdBy,
                                    ].includes(userId)) ||
                                alert.createdBy == userId
                            ) {
                                count++
                            } else if (
                                (alert.currentStep === 'supervisor_approval' &&
                                    (hasApprovalPermission ||
                                        coordinatedProcessIds.includes(
                                            alert.processId
                                        ))) ||
                                alert.createdBy == userId
                            ) {
                                count++
                            }
                        }
                    })
                    this.alertsCount = count
                },
                error => {
                    console.error('Error in alerts listener:', error)
                }
            )
        },
    },
}
</script>

<style>
.v-data-table {
    border: 1px solid #eeeeee;
}
thead {
    background: #eeeeee;
}
</style>
